import AppDrawer from "./AppDrawer";
import AppFooter from "./AppFooter";
import AppJumbotron from "./AppJumbotron";
import AppToolbar from "./AppToolbar";
import AppView from "./AppView";

export default {
  AppDrawer,
  AppFooter,
  AppJumbotron,
  AppToolbar,
  AppView
};
